window.buttonFileUpload = function(input, loadArgs) {
  const wrapper = input.closest('.btn-upload-input');
  if (!wrapper) return;

  const content = wrapper.querySelector('.btn__content');
  const hiddenInput = wrapper.querySelector('input[type="hidden"]');

  if (!input.files.length) return;

  const file = input.files[0];
  const maxSize = 2 * 1024 * 1024;
  const allowedExtensions = ['pdf', 'doc', 'docx'];

  if (file.size > maxSize) {
    noticeError('File is too large. Maximum size is 2MB.');
    input.value = '';
    return;
  }

  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();

  if (!allowedExtensions.includes(fileExtension)) {
    noticeError('Invalid file format. Allowed formats are: PDF, DOC, DOCX');
    input.value = '';
    return;
  }

  if (content) {
    content.textContent = fileName;
  }

  initFile(input);

  if (loadArgs && typeof load === 'function') {
    load(...loadArgs);
  }
};

window.uploadCandidateResume = function(input, uploadUrl, fieldSelector, previewSelector, formId) {
  const wrapper = input.closest('.connect-sec__upload');
  if (!wrapper) return;

  const hiddenInput = document.querySelector(fieldSelector);
  const previewEl = document.querySelector(previewSelector);

  if (!input.files || !input.files.length) return;

  const file = input.files[0];
  const maxSize = 5 * 1024 * 1024;
  const allowedExtensions = ['pdf', 'doc', 'docx', 'txt'];
  const fileName = file.name;
  const fileExtension = fileName.split('.').pop().toLowerCase();

  wrapper.classList.remove('error');
  const nextSibling = wrapper.nextElementSibling;
  if (nextSibling && nextSibling.classList.contains('error-text')) {
    nextSibling.remove();
  }

  if (file.size > maxSize) {
    input.value = '';
    if (hiddenInput) hiddenInput.value = '';
    if (previewEl) previewEl.textContent = '';
    if (typeof window.formValidation === 'function') {
      window.formValidation({
        form_id: formId,
        names: { cv: ['The file must not be greater than 5MB.'] },
      });
    }
    return;
  }

  if (!allowedExtensions.includes(fileExtension)) {
    input.value = '';
    if (hiddenInput) hiddenInput.value = '';
    if (previewEl) previewEl.textContent = '';
    if (typeof window.formValidation === 'function') {
      window.formValidation({
        form_id: formId,
        names: { cv: ['Allowed formats are: PDF, DOC, DOCX, TXT.'] },
      });
    }
    return;
  }

  wrapper.classList.add('is-loading');

  if (window.$) {
    window.$(document).one('ajaxComplete', function() {
      wrapper.classList.remove('is-loading');
    });
  }

  if (typeof initFile === 'function') {
    initFile(input);
  }

  if (typeof load === 'function') {
    load(
      uploadUrl,
      'field=' + fieldSelector,
      'preview=' + previewSelector,
      'form_id=' + formId
    );
  }
};